<script lang="tsx">

import {defineComponent, inject, provide, reactive, Transition} from 'vue';
import Modal from "@/components/common/modal/Modal.vue";

export const MODAL_PROVIDER = Symbol();

type ModalType = (closeModal: () => void) => JSX.Element;

interface ModalProviderApi {
  displayModal: (modal: ModalType) => void
}


export default defineComponent({
  name: 'ModalProvider',
  components: {Modal},
  inheritAttrs: false,
  setup(props, context) {

    const state = reactive<{
      modal: undefined | ModalType,
    }>({
      modal: undefined
    })

    const displayModal = (modal: ModalType ) => {
      state.modal = modal
    }

    provide<ModalProviderApi>(MODAL_PROVIDER, {
      displayModal
    })

    const closeModal = () => {
      state.modal = undefined;
    }

    return () =>
      <>
        {context.slots.default?.()}
        {state.modal != null &&
        <Modal>
          {state.modal(closeModal)}
        </Modal>
        }
      </>
  }
});

export const useModal = () => {
  const result = inject<ModalProviderApi>(MODAL_PROVIDER)
  if (result === undefined) {
    throw new Error("Cannot use Modal outside of ModalProvider")
  }
  return result
}

</script>

<style lang="scss">

</style>
